import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  padding: 1rem;
  border: 1px solid var(--gray_light);
  border-radius: 0.4rem;
  width: 100%;
  max-width: 17.5rem;
  height: max-content;
  position: relative;
  cursor: pointer;

  a {
    display: flex;
    flex-direction: column;
  }

  .product-image {
    position: relative;
    width: 100%;
    height: 13rem;
    margin-bottom: 0.2rem;
    display: flex;
    justify-content: center;
  }

  .product-image img:not(.Selo) {
    margin-left: 1rem;
    width: 100%;
    height: 100%;
    margin-bottom: 0.1rem;
    align-self: center;
    max-width: 13rem;
    max-height: 13rem;
  }

  .product-item-tarjas {
    display: flex;
    flex-direction: column;
    height: 2.1rem;
    overflow: hidden;
  }

  .product-item-tarjas .tarjas {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    color: var(--white);
    font-weight: 700;
    font-size: clamp(0.6rem, 2vw, 0.8rem);
    min-height: 2.1rem;
    text-align: center;

    &:not(:first-child) {
      display: none;
    }
  }

  .product-item-tarjas .frete-gratis-tarja {
    font-size: 0.9rem;
    background-color: var(--black);
  }

  .product-item-tarjas .ganhe-brinde-tarja {
    background-color: var(--green_blue);
  }

  .product-item-tarjas .red-tarja {
    background-color: var(--red);
  }

  .product-item-tarjas .promotion-tarja {
    width: 100%;
  }

  .frete-gratis-tag {
    position: absolute;
    top: 0.7rem;
    left: 0.5rem;
    z-index: 1;
    width: 6rem;
    border-radius: 0.4rem;
  }

  &.have-freight-free .icons-list {
    top: 2.4rem;
  }

  .tag-discount {
    top: 0.5rem;
    right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 4rem;
    width: 4rem;
    height: 100%;
    max-height: 1.5rem;
    position: absolute;
    background-size: contain;
    background-image: url('/images/tag-discount.png');
    background-repeat: no-repeat;
    font-size: 1rem;
    font-weight: 800;
    color: var(--primary_color);
    padding-left: 0.4rem;
    user-select: none;
    z-index: 1;
  }

  .tag-novidade {
    position: absolute;
    top: 0.5rem;
    right: 1rem;
    padding: 0 0.1rem;
    font-weight: 700;
    color: var(--white);
    border-radius: 0.2rem;
    user-select: none;
    font-size: 0.9rem;
    background-color: var(--red);
    z-index: 1;
  }

  .icon.heart-icon,
  .trash-icon {
    cursor: pointer;
    width: 1.4rem;
    align-self: flex-end;
  }

  img.Selo.UltraPremio {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    max-width: 3rem;
  }

  .Selo.Ultradesconto {
    position: absolute;
    top: -0.5rem;
    right: -0.5rem;
    width: 100%;
    height: 100%;
    max-width: 2.2rem;
    max-height: 2.2rem;
  }

  .Selo.CIMED {
    position: absolute;
    bottom: 0.5rem;
    left: -0.5rem;
    width: 100%;
    max-width: 3.5rem;
  }

  .product-item-info {
    display: flex;
    flex-direction: column;
    position: relative;

    > div {
      height: 100%;
      min-height: 9.5rem;
    }

    .product-item-name {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      line-height: 1.1rem;
      font-size: 0.9rem;
      font-weight: 600;
      color: var(--black);
      padding: 0.2rem 0;
      height: 2.4rem;
    }

    .exclusive-product-item {
      height: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      font-size: 0.6rem;
      font-weight: 500;
      margin-top: 1rem;
    }

    .product-item-price-info {
      display: flex;
      flex-direction: column;

      .product-item-old-price-info,
      .product-item-new-price-info {
        display: block;
        width: 100%;
        font-size: 1.2rem;
        color: var(--gray_bold);
        font-weight: 600;
        height: 1.4rem;

        .discount {
          margin-left: 1rem;
          font-size: clamp(7px, 2vw, 11px);
          font-weight: 500;
          padding: 0.2rem 0.4rem;
          font-weight: 700;
          color: var(--white);
          background-color: var(--red);
          width: auto;
          white-space: nowrap;
          align-self: center;
        }
      }

      p.subtitle {
        font-size: 0.9rem;
        width: 2.5rem;
      }

      .product-item-old-price-info {
        display: flex !important;
        margin-top: 0.2rem;
        margin-bottom: 0.1rem;
        height: auto;

        .product-item-old-price {
          display: flex;
          align-items: center;
          width: max-content;
        }
      }

      .product-item-old-price,
      .product-item-new-price {
        white-space: nowrap;
      }

      .product-item-new-price-info {
        display: flex !important;
        align-items: center;
        color: var(--primary_color);
      }

      .product-item-price-for {
        font-size: 1.2rem;
        font-weight: 600;
        color: var(--primary_color);
        white-space: nowrap;
        align-items: center;
      }

      .product-item-price-unity-text {
        font-size: 0.9rem;
        color: var(--primary_color);
      }

      .product-item-price-unity {
        font-weight: 700;
        color: var(--primary_color);

        span {
          color: rgb(64, 64, 64);
          font-weight: 400;
        }
      }

      .product-item-price-parcel {
        color: rgb(64, 64, 64);
        font-weight: 500;
        width: 100%;

        &.dont-show-installment {
          display: flex;
          align-items: center;
          color: var(--primary_color);
          font-weight: 600;

          span {
            font-size: 1.2rem;
          }
        }
      }

      .product-item-price-pix {
        display: flex;
        align-items: center;
        color: var(--red);

        b {
          font-size: 1.2rem;
          font-weight: 600;
          white-space: nowrap;
        }
      }

      .product-item-discount-parcel {
        display: flex;
        flex-direction: column;
        font-size: 0.8rem;
        font-weight: 500;
        color: var(--red);
        height: 1rem;
      }
    }
  }

  .product-item-old-price-info .product-item-old-price {
    position: relative;
  }

  .product-item-x-price-old {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);

    &::before {
      transform: translate(-50%, -50%) rotate(10deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-10deg);
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 1px;
      background-color: var(--red);
      transform-origin: center;
      top: 50%;
      left: 50%;
    }
  }

  .product-item-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
    margin-top: 0.4rem;
    min-height: 4.25rem;

    button {
      max-height: 1.9rem;
      min-height: 1.9rem;
    }

    .button-component {
      margin-top: auto;
    }

    #button-exclusive-product {
      background-color: var(--primary_color);
      border-color: var(--primary_color);
      align-self: flex-end;
    }

    #button-exclusive-product:hover,
    #button-send-me-email:hover {
      opacity: 0.8;
      color: var(--white);
    }

    #button-unavailable-product {
      opacity: 1;
      color: var(--black);
      background-color: var(--green_light);
      border-color: var(--green_light);
    }

    #button-send-me-email,
    #button-unavailable-product {
      padding: 0.7rem 0;
    }
  }

  .product-item-group-buttons {
    display: grid;
    grid-template-areas: 'item1 item2';
    column-gap: 0.4rem;
    width: 100%;
    min-height: 4.25rem;

    &.product-unavailable {
      display: flex;
      flex-direction: column;
      align-self: flex-end;
    }

    .item-counter {
      grid-area: item1;
      width: 100%;
      max-height: 1.9rem;
      margin-top: auto;

      button {
        font-size: 1rem;
        width: 100%;
      }

      input,
      .shopping-icon {
        width: 1.6rem;
      }

      .shopping-icon {
        height: 0.75rem;
      }
    }

    #button-buy {
      grid-area: item2;
      color: var(--black);
      border-color: var(--green_light);
      background-color: var(--green_light);
      width: 100%;
    }

    #button-add-to-cart {
      align-items: center;
      grid-area: item3;
      gap: 0.6rem;
    }

    #button-add-to-cart,
    #button-send-me-email {
      background-color: var(--black);
      border-color: var(--black);
      color: var(--green_light);
      margin-top: 0.4rem;
    }
  }

  .product-item-button #button-exclusive-product,
  .product-item-group-buttons.product-unavailable button {
    width: 100%;
  }

  @media (max-width: 768px) {
    .icons-list {
      display: none;
    }

    /* img.Selo.UltraPremio {
      display: inline-block;
    } */

    .product-image.have-selo img:not(.Selo.UltraPremio) {
      margin-left: 0;
    }

    .product-item-tarjas .tarjas {
      font-size: clamp(0.6rem, 2vw, 0.7rem);
    }

    .product-item-info .product-item-price-info .product-item-discount-parcel {
      font-size: 0.7rem;
    }

    .button-component {
      width: 100%;
      min-width: 0;
      font-size: 0.6rem;
    }
  }

  @media (max-width: 520px) {
    .product-item-button {
      margin-top: auto;
      min-height: 4.2rem;
    }

    .product-item-group-buttons {
      grid-template-areas:
        'item1'
        'item2';
      row-gap: 0.4rem;

      #button-add-to-cart img {
        display: none;
      }

      .button-component,
      #button-send-me-email,
      #button-unavailable-product {
        font-size: 0.6rem;
        width: 100%;
        padding: 0.8rem 1.2rem;
      }
    }
  }

  @media (max-width: 470px) {
    .product-item-tarjas,
    .product-item-tarjas .tarjas {
      height: 1.6rem;
    }

    .product-item-info .product-item-price-info .product-item-price-unity-text {
      font-size: 0.7rem;
    }

    .frete-gratis-tag {
      width: 4.3rem;
    }

    .tag-novidade {
      font-size: 0.7rem;
    }

    .cards-list-mobile {
      height: 3rem;
    }

    .product-item-tarjas .tarjas {
      min-height: 0;
    }

    .button-component {
      font-size: 0.5rem;
    }

    .product-item-group-buttons {
      grid-template-areas:
        'item1'
        'item2' !important;
    }
  }

  @media (max-width: 455px) {
    .product-item-tarjas {
      height: 2.1rem;
    }
  }

  @media (max-width: 450px) {
    .tag-discount,
    .tag-novidade {
      font-size: 0.7rem;
    }

    .tag-discount {
      width: 3rem;

      span {
        height: 1.2rem;
      }
    }

    .product-item-tarjas {
      .frete-gratis-tarja {
        font-size: 0.8rem;
      }
    }
  }

  @media (max-width: 360px) {
    .product-item-price-for {
      align-self: flex-start;
    }
  }

  @media (max-width: 340px) {
    .cards-list-mobile {
      height: inherit;
    }

    .product-item-info > div {
      min-height: 0;
    }
  }
`;
